import React, { useCallback, useState } from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import ConfirmationDialog from 'core/components/ConfirmationDialog';
import { useSnackbar } from 'notistack';
import { useNavigate, createSearchParams } from "react-router-dom";
import { getSeatSharingInfo, subscribeToSeatSharing } from 'services/operations/seatSharing';

const SeatSharingCard = ({library}) => {

  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [modalOptions, setModalOptions] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const routeToSeatSharingPage = useCallback(() => {
    const params = {id: library?.libraryId, type: 'LIBRARY'}
      navigate(`/operations/revenue-sharing/seat-sharing/?${createSearchParams(params)}`);
  },[navigate, library]);
  

  function onSeatSharingCardClick() {
    const data={
      propertyId: library?.libraryId,
      propertyType: 'LIBRARY'
    }
    getSeatSharingInfo(data).then(({response, error}) => {
      if(response) {
        if(response?.subscribed){
          routeToSeatSharingPage();
        }else{
          loadConfirmModal(response);
        }
      }else{
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  function loadConfirmModal(response) {
    const data={
      title: 'Seat Sharing',
      confirmationText: 'Proceed',
      content: response?.description?.split('\n').join('<br/>')
    };
    setModalOptions(data);
    setOpenModal(true);
  }

  const onConfirm = useCallback(() => {
    const data={
      libraryId: library?.libraryId
    }
    subscribeToSeatSharing(data).then(({response, error}) => {
      if(response){
        enqueueSnackbar("You have successfully activated seat sharing", {variant: 'success'});
        setOpenModal(false);
        routeToSeatSharingPage();
      }else{
        setOpenModal(false)
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  },[enqueueSnackbar, library?.libraryId, routeToSeatSharingPage]);
  
  return (
    <>
      <Card sx={{ minWidth: 275, backgroundColor:'#f8f8f8', cursor:'pointer' }} onClick={onSeatSharingCardClick}>
        <CardContent>
          <Typography variant="h6" component="div">
            Seat Sharing
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Sell a set of seats to Webook and we'll take care of the occupancy
          </Typography>
        </CardContent>
      </Card>
      <ConfirmationDialog  open={openModal} options={modalOptions} onCancel={() => setOpenModal(false)} onConfirm={onConfirm} />
    </>
  );
}
 
export default React.memo(SeatSharingCard);
